import { GET_ALL_CUSTOMER_LOADS, CUSTOMER_LOADS_LOADING, GET_CUSTOMER_LOAD, CLEAR_CUSTOMER_LOAD } from './types'

const initState = {
  loads: {
    data: [],
    query: { first: 0, limit: 5, totalRecords: 0 },
  },
  load: {},
  isLoading: false,
}

export default function customerLoadReducer(state = initState, action) {
  switch (action.type) {
    case CLEAR_CUSTOMER_LOAD:
      return {
        ...state,
        load: {},
      }
    case GET_ALL_CUSTOMER_LOADS:
      return {
        ...state,
        loads: action.payload,
      }
    case GET_CUSTOMER_LOAD:
      return {
        ...state,
        load: action.payload,
      }
    case CUSTOMER_LOADS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    default:
      return state
  }
}
